<template>
  <td
    class="m-table-cell-container"
    :class="{
      'm-table-cell-container_left': alignLeft,
      'm-table-cell-container_right': alignRight,
      'm-table-cell-container_center': alignCenter,
      'm-table-cell-container_sortable': sortable,
      'm-table-cell-container_right-border': hasRightBorder,
      'm-table-cell-container_sticky-column': sticky,
      'm-table-cell-container_column-sticked': isColumnSticked,
      'm-table-cell-container_is-first': isFirst,
      'm-table-cell-container_is-last': isLast,
      'm-table-cell-container_last-nested-row-cell': isLastRow && isNested
    }"
    :style="cssVars"
  >
    <div
      v-if="sticky"
      class="m-table-column__sticky-trigger"
    />
    <slot />
  </td>
</template>

<script>
  import getCssVarNameForColumn from 'components/Data/Tables/MTable/utils/getCssVarNameForColumn';

  export default {
    name: 'MTableCellContainer',
    props: {
      enabledKey: {
        type: String,
        default: null
      },
      align: {
        type: String,
        default: 'right'
      },
      hasRightBorder: {
        type: Boolean,
        default: false
      },
      sortable: Boolean,

      /*
       * object of sticky offsets
       * { columnKey: XXXpx, ...}
       */
      stickyOffset: {
        type: Object,
        default: Object
      },
      itemKey: {
        type: String,
        default: ''
      },
      stickyParamKey: {
        type: String,
        default: ''
      },

      // is cell Sticky, enables position: sticky
      sticky: Boolean,

      /*
       * object with column and stickied flag
       * {columnKey: isSticky, .... }
       */
      stickedColumns: {
        type: Object,
        default: Object
      },
      tableRow: {
        type: Object,
        default: Object
      },
      uniqueKeyAttr: {
        type: String,
        default: 'id'
      },
      triggersDropdown: {
        type: Boolean,
        default: false
      },
      isDropdownEnabledPredicate: {
        type: Function,
        default: () => false
      },
      cellColor: {
        type: String,
        default: null
      },
      tableParams: {
        type: Object,
        required: true
      },
      isFirst: {
        type: Boolean
      },
      isLast: {
        type: Boolean
      },
      isLastRow: {
        type: Boolean,
        default: false
      },
      isNested: {
        type: Boolean,
        default: false
      },
      withSummaryRow: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      cssVars () {
        return {
          '--sticky-left-offset': this.stickyLeftOffset,
          '--current-cell-width': `var(${getCssVarNameForColumn(this.itemKey, 'width')})`
        };
      },
      stickyKey () {
        return this.stickyParamKey || this.itemKey;
      },
      isColumnSticked () {
        return this.sticky && this.stickedColumns[this.stickyKey];
      },
      stickyLeftOffset () {
        return this.stickyOffset[this.stickyKey];
      },
      alignRight () {
        return this.align === 'right';
      },
      alignCenter () {
        return this.align === 'center';
      },
      alignLeft () {
        return this.align === 'left';
      }
    },
    methods: {

    }
  };
</script>

<style>
  .m-table-cell-container {
    --current-cell-width: 'auto';

    color: var(--text-main-color);
    vertical-align: top;
  }

  .m-table-cell-container_right-border {
    border-right: 1px solid var(--border-color);
  }

  .m-table-cell-container_column-sticked.m-table-cell-container_right-border {
    border-right-color: var(--background-color);
  }

  .m-table-cell-container_sticky-column {
    position: sticky;
    left: var(--sticky-left-offset);
    z-index: 19;

    background: var(--row-cell-background);
  }

  .m-table-cell-container_last-nested-row-cell {
    border-bottom: 1px solid var(--border-color);
  }

  .m-table-cell-container_sticky-column::after {
    content: '';

    position: absolute;
    top: 0;
    right: -30px;

    width: 30px;
    height: 100%;

    box-shadow: inset 31px 0 18px -20px var(--sticky-cell-vertical-shadow-color);

    opacity: 0;

    transition: opacity 100ms;

    pointer-events: none;
  }

  .m-table-cell-container_column-sticked::after {
    opacity: 1;
  }

  .m-table-cell-container_right > * {
    text-align: right;

    /* this is to align M-Link (display: flex) */
    justify-content: flex-end;
  }

  .m-table-cell-container_center > * {
    text-align: center;

    /* this is to align M-Link (display: flex) */
    justify-content: center;
  }

  .m-table-cell-container_left > * {
    text-align: left;

    /* this is to align M-Link (display: flex) */
    justify-content: flex-start;
  }

  .m-table-cell-container_is-first.m-table-cell-container > .m-table-cell {
    padding-left: 14px;
  }

  .m-table-cell-container_is-last.m-table-cell-container > .m-table-cell {
    padding-right: 14px;
  }

  .m-table-cell-container_right.m-table-cell-container_sortable > .m-table-cell {
    padding-right: 19px;
  }

  .m-table-cell-container_is-last.m-table-cell-container_right.m-table-cell-container_sortable .m-table-cell,
  .m-table-cell-container_right.m-table-cell-container_sortable.m-table-cell-container_right-border > .m-table-cell {
    padding-right: 27px;
  }

</style>
